module.exports = __webpack_public_path__ + "static/media/user_padrao.76654c1c.png";